import type { ScreenModule } from "../../../app/screen-module";
import { InviteJoinPage } from "../auth-pages";

export default {
	id: "public.invite",
	path: "/invite/:token",
	area: "public",
	label: "招待から参加",
	roles: [],
	backing: "MOCK_ONLY",
	enabled: true,
	component: InviteJoinPage,
} satisfies ScreenModule;
